import api from 'Application/api/api';

const getVehiclesTasksProgress = (cancelToken = null) =>
    api.get('/measures/vehicles/tasks-progress', { cancelToken });

export default getVehiclesTasksProgress;
